import { IUserModel } from "../models/DTO/UserModel";
import { IUserCompanyPermissionModel } from "../models/DTO/UserCompanyPermissionModel";
import { useContext } from "react";
import { RdContextType } from "../@types/Rd";
import RdContext from "../contexts/RdProvider";

export type PermissionsType = "Guest" | "Presenter" | "Director" | "Admin" | "DisclosuresDeliberation" | "Master";

export type userPermissionsParams = {
    permissions: Map<string, IUserCompanyPermissionModel>,
    isAdAuthenticated: boolean,
    role?: PermissionsType,
    user?: IUserModel,
    companyId?: string
    isMasterActive?: boolean
}

const isMasterUser = (permission: PermissionsType, user: IUserModel, isMasterActive: boolean): boolean => {
    const result: boolean = (permission == "Master" && user.IsMaster && isMasterActive);
    return result;
}

export default function isUserAuthorized({ role, permissions, isAdAuthenticated, user, companyId, isMasterActive }: userPermissionsParams): boolean {

    if (!isAdAuthenticated || user == null || !user.IsActive || user.Id <= 0 || companyId == null || companyId == "") return false;

    if (role == "Master")
        return isMasterUser("Master", user, isMasterActive || false);

    const premissionKey: string = `${user.Id}|${companyId}`;

    if (user.Permissions == null || user.Permissions?.size <= 0) user.LoadPermissions();

    if (permissions == null || permissions.size <= 0) return false;

    if ((user.Permissions == null || permissions == null) || (!user.Permissions.has(companyId) && !permissions.has(premissionKey))) return false;

    const userPermissions = user.Permissions.get(companyId) || permissions.get(premissionKey)!,
        result = ((role == "DisclosuresDeliberation" || role == "Admin") && userPermissions.IsActive && userPermissions.IsAdmin)
            || ((role == "DisclosuresDeliberation" || role == "Director") && userPermissions.IsActive && userPermissions.IsDirector)
            || (role == "Presenter" && userPermissions.IsActive && userPermissions.IsBidder)
            || (role == "Guest" && userPermissions.IsActive && userPermissions.IsGuest)
            || false;

    return result;
}

export const isAuthorized = (role: PermissionsType): boolean => {
    const checker = useContextCredentials(),
        result: boolean = isUserAuthorized({ ...checker, role });

    return result;
}

export const useContextCredentials = (): userPermissionsParams => {
    const { RdToken, currentCompany, userInfo, isAdAuthenticated, Permissions, IsMasterActive } = useContext<RdContextType>(RdContext),
        companyId = currentCompany?.Id.toString(),
        defaultChecker: userPermissionsParams = { isAdAuthenticated, permissions: Permissions, companyId, user: userInfo, isMasterActive: IsMasterActive };
    return defaultChecker;
}